import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';

const _axios = HttpService.getAxiosClient();

const buildProjectReportParams = ({
  employeeName,
  employeeCode,
  isManager,
  projectIds,
  pageNumber,
  pageSize,
  sortBy = 'employeeName',
  sortDirection = 'ASC',
}) => {
  const params = new URLSearchParams();
  if (employeeName?.trim()) {
    params.append('employeeName', employeeName.trim());
  }
  if (employeeCode?.trim()) {
    params.append('employeeCode', employeeCode.trim());
  }
  if (isManager === true) {
    params.append('isManager', 'true');
  }
  if (Array.isArray(projectIds)) {
    projectIds.forEach((id) => {
      if (id != null) {
        params.append('projectIds', id);
      }
    });
  }
  if (pageSize != null) {
    params.append('pageSize', pageSize);
    params.append('pageNumber', pageNumber ?? 0);
  }
  params.append('sortBy', sortBy);
  params.append('sortDirection', sortDirection);
  return params.toString();
};

export const getProjectReport = async (filters) => {
  try {
    const query = buildProjectReportParams(filters);
    const response = await _axios.get(
      `${ADMIN_PATH}/report/project?${query}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const downloadProjectReport = async (filters) => {
  try {
    const query = buildProjectReportParams({
      ...filters,
      pageNumber: undefined,
      pageSize: undefined,
    });
    const response = await _axios.get(
      `${ADMIN_PATH}/report/project/download?${query}`,
      { responseType: 'blob' },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
